function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { j as s } from "./index.es33.js";
import { clsx as e } from "./index.es105.js";
import { Typography as m } from "./index.es35.js";
import "./index.es36.js";
import { createInlineStyles as c } from "./index.es583.js";
import o from "./index.es584.js";
var g = function g(_ref) {
  var p = _ref.id,
    t = _ref.title,
    r = _ref.description,
    i = _ref.tooltipRef,
    l = _ref.offset,
    a = _ref.className,
    _ref$isAbsolute = _ref.isAbsolute,
    y = _ref$isAbsolute === void 0 ? !0 : _ref$isAbsolute;
  return s.jsxs("div", {
    style: c({
      offset: l
    }),
    id: p,
    className: e(e(o.tooltip, a !== null && a !== void 0 ? a : ""), _defineProperty({}, o.tooltipAbsolute, y)),
    ref: i,
    children: [typeof t == "string" ? s.jsx(m.Body2, {
      className: o.text,
      children: t
    }) : t, typeof r == "string" ? s.jsx(m.Body2, {
      className: o.description,
      children: r
    }) : r]
  });
};
export { g as Tooltip };